import segment from '@segment/snippet';
import { env } from '@/config';

export function injectTracking() {
  const jsSnippet = segment.min({
    host: env.VUE_APP_SEGMENT_HOST,
    apiKey: env.VUE_APP_SEGMENT_API_KEY,
  });

  // loadAJS
  const script = document.createElement('script');
  script.innerHTML = jsSnippet;

  document.head.appendChild(script);
}

export function sendTrackingPageView(path) {
  if (!window.analytics) {
    return;
  }
  window.analytics.page({
    url: path,
  });
}

export function sendTrackingEvent(eventName, eventValue = {}) {
  if (!window.analytics) {
    return;
  }
  window.analytics.track(eventName, eventValue);
}

export function sendTrackingIdentity(accountUUID, name, email, fingerprint) {
  if (!window.analytics) {
    return;
  }
  const identity = fingerprint ?? accountUUID;
  window.analytics.identify(
    identity,
    {
      accountUUID, email, name, fingerprint,
    },
  );
}

export function sendTrackingScheduleMetrics(availableIn3Days, availableIn7Days, hoursUntilEarliest) {
  if (!window.analytics) {
    return;
  }
  const eventType = 'TherapistScheduleMetrics';
  const label3Days = '3_days_available_slots';
  const label7Days = '7_days_available_slots';
  const labelEarliest = 'hours_until_earliest_available_slot';

  window.analytics.track({
    event: eventType,
    label: label3Days,
    value: availableIn3Days,
  });

  window.analytics.track({
    event: eventType,
    label: label7Days,
    value: availableIn7Days,
  });

  window.analytics.track({
    event: eventType,
    label: labelEarliest,
    value: hoursUntilEarliest,
  });
}
